import loadable from '@loadable/component';

export const CmsFlashCardQuizBlockLoadable = loadable(
  () => import('./CmsFlashCardQuizBlock'),
  { resolveComponent: (module) => module.CmsFlashCardQuizBlock },
);
